import { ByodApplyForm } from '../../components/byod-apply-form/byod-apply-form';

export const ByodApplyPage = () => <ByodApplyForm />;
